import iconPhraseForecastMapping from '../assets/data/iconPhraseForecastMapping.json';
import iconPhraseMapping from '../assets/data/iconPhraseMapping.json';

/**
 *
 * @param {number} { iconCodeExtend } - icon code from API response corresponding with a weather phrase found in the hardcoded list
 */
export const getWeatherPhrase = data => {
  const { iconCodeExtend = 0 } = data ?? {};

  return iconPhraseMapping[iconCodeExtend];
};

export const getForecastWeatherPhrase = data => {
  const { iconCodeExtend = 0 } = data ?? {};

  return iconPhraseForecastMapping[iconCodeExtend];
};
